import { NavigationGuardNext, Route } from 'vue-router';
import { NamedLocation } from '../types';
import { isAiTemplateEnabled } from '@/ui/helpers/featureHelper';

export function guardAiTemplateFeatureToggle(
  to: Route,
  from: Route,
  next: NavigationGuardNext,
): void {
  if (!isAiTemplateEnabled()) {
    const redirectTo: NamedLocation = { name: 'checklistChooseTemplate' };
    next(redirectTo);
  }
  next();
}
